import React from 'react';
import styled from 'styled-components';
import { FiMinimize2 } from 'react-icons/fi';
import Portal from '@/components/portal';
import { DEVICE_NAV_PARENT_ID } from '@/features/editor/preview-navigation/index';

interface ShowAddedElementsButtonProps {
  isVisible: boolean;
  onClick: () => void;
}

export function ShowAddedElementsButton({
  isVisible,
  onClick,
}: ShowAddedElementsButtonProps) {
  if (!isVisible) return null;

  return (
    <Portal selector={`#${DEVICE_NAV_PARENT_ID}`}>
      <ButtonWrapper>
        <Button onClick={onClick}>
          <FiMinimize2 size={14} />
          Show added elements
        </Button>
      </ButtonWrapper>
    </Portal>
  );
}

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const Button = styled.button`
  appearance: none;
  outline: none;
  color: #171b21;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.09);
  background-color: #fff;
  border-radius: 1.5rem;
  padding: 0.725rem 1.2rem;
  height: 3.05rem;
  font-family: 'Inter', serif;
  font-weight: 500;
  font-size: 1.2rem;
  cursor: pointer;
  white-space: nowrap;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 0.8rem;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: rgba(153, 153, 153, 0.15);
  }

  &:active {
    transform: scale(0.98);
  }
`;
